import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CommonService } from "src/app/core/services/common.service";
import { TdspCommonService } from "src/app/core/services/tdsp/tdsp-common.service";
import { tdspConversionPixel } from "src/app/models/tdsp/tdsp-conversion-pixel";

@Component({
  selector: "app-tdsp-create-conversion-pixel",
  templateUrl: "./tdsp-create-conversion-pixel.component.html",
  styleUrl: "./tdsp-create-conversion-pixel.component.scss",
})
export class TdspCreateConversionPixelComponent implements OnInit {
  activeStep: string;
  globalParams: Object = {};

  conversionPixel: tdspConversionPixel;

  constructor(
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private tdspCommonService: TdspCommonService
  ) {
    this.conversionPixel = {
      name: "",
      dynamic_parameters: [],
      containsParam: false,
    };
  }

  ngOnInit() {
    let params = this.commonService.getObjfromParams(
      this.activatedRoute.snapshot.queryParamMap
    );
    this.globalParams = this.commonService.getclientID(params);

    this.activeStep = this.commonService.sideNavStepChange(
      "basic_step",
      "tdspConversionPixel",
      "Conversion Pixel"
    );
    this.commonService.sideMenuStatus(
      [{ id: "basic_step", status: true }],
      "tdspConversionPixel"
    );
  }

  basicStepChange(event) {
    this.tdspCommonService.preparePayloadAndSubmitConversionPixel(
      event,
      "create",
      this.globalParams
    );
  }
}
